"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dsnFromString = dsnFromString;
exports.dsnToString = dsnToString;
exports.makeDsn = makeDsn;

var _debugBuild = require("./debug-build.js");

var _logger = require("./logger.js");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/** Regular expression used to parse a Dsn. */
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */


function dsnToString(dsn, withPassword = false) {
  const host = dsn.host,
        path = dsn.path,
        pass = dsn.pass,
        port = dsn.port,
        projectId = dsn.projectId,
        protocol = dsn.protocol,
        publicKey = dsn.publicKey;
  return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */


function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);

  if (!match) {
    // This should be logged to the console
    (0, _logger.consoleSandbox)(() => {
      // eslint-disable-next-line no-console
      console.error(`Invalid Sentry Dsn: ${str}`);
    });
    return undefined;
  }

  const _match$slice = match.slice(1),
        _match$slice2 = _slicedToArray(_match$slice, 6),
        protocol = _match$slice2[0],
        publicKey = _match$slice2[1],
        _match$slice2$ = _match$slice2[2],
        pass = _match$slice2$ === void 0 ? '' : _match$slice2$,
        _match$slice2$2 = _match$slice2[3],
        host = _match$slice2$2 === void 0 ? '' : _match$slice2$2,
        _match$slice2$3 = _match$slice2[4],
        port = _match$slice2$3 === void 0 ? '' : _match$slice2$3,
        _match$slice2$4 = _match$slice2[5],
        lastPath = _match$slice2$4 === void 0 ? '' : _match$slice2$4;

  let path = '';
  let projectId = lastPath;
  const split = projectId.split('/');

  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop();
  }

  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);

    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsnFromComponents({
    host,
    pass,
    path,
    projectId,
    port,
    protocol: protocol,
    publicKey
  });
}

function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId
  };
}

function validateDsn(dsn) {
  if (!_debugBuild.DEBUG_BUILD) {
    return true;
  }

  const port = dsn.port,
        projectId = dsn.projectId,
        protocol = dsn.protocol;
  const requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  const hasMissingRequiredComponent = requiredComponents.find(component => {
    if (!dsn[component]) {
      _logger.logger.error(`Invalid Sentry Dsn: ${component} missing`);

      return true;
    }

    return false;
  });

  if (hasMissingRequiredComponent) {
    return false;
  }

  if (!projectId.match(/^\d+$/)) {
    _logger.logger.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);

    return false;
  }

  if (!isValidProtocol(protocol)) {
    _logger.logger.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);

    return false;
  }

  if (port && isNaN(parseInt(port, 10))) {
    _logger.logger.error(`Invalid Sentry Dsn: Invalid port ${port}`);

    return false;
  }

  return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */


function makeDsn(from) {
  const components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);

  if (!components || !validateDsn(components)) {
    return undefined;
  }

  return components;
}